import { Routes } from '@angular/router';
import { loginRoutes } from '@softapps/allgemein/login';
import { settingsRoutes } from '@softapps/allgemein/utils';
import { passwordRoutes } from '@softapps/allgemein/password';
import { moduleRoutes } from '@softapps/allgemein/modules';
import { eslLinkRoutes } from '@softapps/handel/esl-link';
import { gesamtabfrageRoutes } from '@softapps/wws/gesamtabfrage';
import { bestellvorschlagRoutes } from '@softapps/mde/bestellvorschlag';
import { bestellerfassungRoutes } from '@softapps/mde/bestellerfassung';
import { etikettendruckRoutes } from '@softapps/mde/etikettendruck';
import { warenverprobungRoutes } from '@softapps/mde/warenverprobung';
import { retourenRoutes } from '@softapps/mde/retouren';
import { artikelvorratRoutes } from '@softapps/mde/artikelvorrat';
import { artikelInfoRoutes } from '@softapps/wws/artikel-info';
import { lagerInventurRoutes } from '@softapps/mde/inventur';
import { eslLinkStorageRoutes } from '@softapps/handel/esl-link-storage';

export const shellRoutes: Routes = [
  //Allgemein
  ...moduleRoutes,
  ...settingsRoutes,

  ...gesamtabfrageRoutes,

  ...bestellvorschlagRoutes,
  ...bestellerfassungRoutes,
  ...etikettendruckRoutes,
  ...lagerInventurRoutes,
  ...warenverprobungRoutes,
  ...retourenRoutes,
  ...artikelvorratRoutes,

  ...artikelInfoRoutes,

  ...eslLinkRoutes,
  ...eslLinkStorageRoutes,
];

export const publicRoutes: Routes = [
  ...loginRoutes,
  ...passwordRoutes,
  ...settingsRoutes,
];

/*
export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('@softapps/core').then((o) => o.ShellComponent),
    children: [
      //Allgemein
      ...moduleRoutes,
      ...settingsRoutes,

      ...gesamtabfrageRoutes,

      ...bestellvorschlagRoutes,
      ...bestellerfassungRoutes,
      ...etikettendruckRoutes,
      ...lagerInventurRoutes,
      ...warenverprobungRoutes,
      ...retourenRoutes,
      ...artikelvorratRoutes,

      ...artikelInfoRoutes,

      ...eslLinkRoutes,
    ],
    canActivate: [AuthenticationGuard],
  },
  {
    path: '',
    loadComponent: () =>
      import('@softapps/core').then((o) => o.PublicShellComponent),
    children: [ ...loginRoutes, ...passwordRoutes, ...settingsRoutes],
  },
  {
    path: '**',
    redirectTo: '/',
  }
];*/
